import { cx } from 'emotion';
import {
  useState,
  Suspense,
  ReactNode,
  ComponentType,
  CSSProperties,
} from 'react';

import Drawer from '@ezugi/ui/components/Drawer/Drawer';

import DrawerToggler from './DrawerToggler';
import {
  bodyClassName,
  drawerClassName,
  drawerContainer,
  headerClassName,
  drawerToggleButton,
  panelClassName,
  toggleStyles,
  drawerStyles,
} from './GameDrawer.css';

export type GameDrawerProps = {
  align: 'left' | 'right';
  hideOnGameOpen?: boolean;
  togglerContainerClassName?: string;
  toggler?: ComponentType<any>;
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
  panelStyle?: CSSProperties;
}

function GameDrawer({
  hideOnGameOpen = false,
  className,
  togglerContainerClassName,
  children,
  toggler,
  panelStyle,
  align,
  ...props
}: GameDrawerProps) {
  const [ on, toggle ] = useState(!hideOnGameOpen);

  const Toggler = toggler ?? DrawerToggler;

  return (
    <div
      className={cx(drawerContainer, drawerStyles[align], className)}
    >
      <Suspense fallback={null}>
        <Drawer
          data-e2e={`${align}-side-drawer`}
          align={align}
          open={on}
          headerClassName={headerClassName}
          bodyClassName={bodyClassName}
          panelClassName={panelClassName}
          className={drawerClassName}
          showHeader={false}
          showBackdrop={false}
          panelStyle={panelStyle}
          hideContentOnClose={false}
          {...props}
        >
          {children}
          <div
            data-e2e={`${align}-side-drawer-button`}
            onClick={() => {
              toggle(!on);
            }}
            className={cx(drawerToggleButton, toggleStyles[align], togglerContainerClassName)}
          >
            <Toggler />
          </div>
        </Drawer>
      </Suspense>
    </div>
  );
}

export default GameDrawer;
